import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RightPanel} from '../right-panel.class';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigurationService} from '../../../../../configuration/configuration.service';
import {AssetsManagerService} from '../../../../../data/assets/assets-manager.service';
import {ToastService} from '../../../../../shared/services/toast.service';
import {MessagesService} from '../../../../../data/messages/messages.service';
import {FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MessageRecipientModel} from '../../../models/message-recipient.model';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Observable} from 'rxjs';
import {MatAutocomplete, MatAutocompleteTrigger, MatOptgroup, MatOption } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import {MessageRecipientCollectionModel} from '../../../models/message-recipient-collection.model';
import {ActionMenuItem, ActionMenuItemSubMenu} from '../../../../../shared/models/action-menu-item.class';
import { MessageDeliveryDto, MessageModel } from '../../../models/message.model';
import {ShortDateOrTimePipe} from '../../../../../shared/formatting/short-date-or-time.pipe';
import {ConfirmDeleteMessageDialogComponent} from './dialogs/confirm-delete-message-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DrawerContent} from '../../../../../layouts/right-drawer/right-drawer.component';
import { Asset } from '../../../models/asset.class';
import { DateFilter, TimeRangeFilter } from 'src/app/shared/models/DateFilter';
import { MultiSelectFilter } from '../../../../../shared/components/multi-select-component';
import { MessageSource } from '../../../../../data/websocket/model/message.event';
import { ServicesSocketService } from '../../../../../data/websocket/services-socket.service';
import { MatIcon } from '@angular/material/icon';
import { FilterButtonComponent } from '../../../../../shared/components/buttons/filter-button/filter-button.component';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatLabel } from '@angular/material/form-field';
import { MatChipGrid, MatChipInput, MatChipRow } from '@angular/material/chips';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FilterBarComponent } from '../../../../../shared/components/filter-bar/filter-bar.component';
import { CardMenuItemComponent } from '../../../../../shared/components/card-menu-item/card-menu-item.component';
import { MessageComponent } from './message/message.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ManageTemplatesComponent } from './dialogs/manage-templates/manage-templates.component';
import { MessageTemplate } from '../../../../../shared/models/configuration.model';

export const subFilter = (recipients: any[], value: any): MessageRecipientModel[] => {
  const filterValue = value.hasOwnProperty('name') ? value.name.toLowerCase() : value.toLowerCase();

  return recipients.filter(item => item.name.toLowerCase().indexOf(filterValue) === 0);
};

interface MessageRecipient {
  type: string;
  recipients: MessageRecipientModel[];
}

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  imports: [
    MatIcon,
    FilterButtonComponent,
    NgClass,
    MatButton,
    MatFormField,
    MatLabel,
    MatChipGrid,
    MatChipRow,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatChipInput,
    MatAutocomplete,
    MatOptgroup,
    MatOption,
    AsyncPipe,
    MatInput,
    FormsModule,
    MatProgressSpinner,
    FilterBarComponent,
    CardMenuItemComponent,
    MessageComponent,
    MatIconButton,
    MatTooltip,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
  ],
  providers: [
    ShortDateOrTimePipe,
  ]
})
export class MessagesComponent extends RightPanel implements OnInit, OnDestroy {
  isSending = false;
  showNewMessageForm = false;
  openedMessage: MessageModel = null;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredRecipients: Observable<MessageRecipient[]>;
  recipientsForm = new FormControl();
  formData = {
    subject: '',
    body: '',
    recipients: [],
  };
  availableRecipients: MessageRecipient[];
  recipientsInitialized = false;
  selectedVehicle: Asset;

  dateFilter: DateFilter;
  driverFilter: MultiSelectFilter<number>;
  authorFilter: MultiSelectFilter<string>;

  messages: MessageModel[];
  items: ActionMenuItem[] = [];

  templates: MessageTemplate[] = [];

  @ViewChild('recipientInput') recipientInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  TimeRangeFilter = TimeRangeFilter;

  constructor(
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected configurationService: ConfigurationService,
    protected assetsManager: AssetsManagerService,
    private messagesService: MessagesService,
    private serviceSocketService: ServicesSocketService,
    private dialog: MatDialog,
    private shortDateOrTimePipe: ShortDateOrTimePipe,
    private toast: ToastService,
  ) {
    super(DrawerContent.MESSAGES, router, activatedRoute, configurationService, assetsManager);
    this.filteredRecipients = this.recipientsForm.valueChanges.pipe(
      startWith(''),
      map((input: string) => this._filterGroup(input))
    );
  }

  ngOnInit() {
    this.initialize();
    this.loadConfiguration();
    this.selectedVehicle = this.asset;
    this.loadRecipients();

    // update messages if any update comes through WS
    const messageReadSubscription = this.serviceSocketService.onMessage(MessageSource.MESSAGE).subscribe(event => {
      if (!!this.messages) {
        const message = this.messages.find((data: MessageModel) => data.id === event.data.messageId);
        if (message) {
          const values = message.messageDeliveries.filter((delivery: MessageDeliveryDto) => delivery.driverId === event.data.driverId);
          values.forEach(value => (value.seenAt = String(event.data.seenAt)));
        }
      }
    });
    this.openSubscriptions.push(messageReadSubscription);

    // reload recipients when active shifts change
    const servicesSubscription = this.serviceSocketService.onMessage(MessageSource.SHIFT).subscribe(message => {
      setTimeout(() => this.loadRecipients(), 2000);
    });
    this.openSubscriptions.push(servicesSubscription);
  }

  ngOnDestroy() {
    this.unsubscribe();
    this.availableRecipients = undefined;
    this.recipientsInitialized = false;
  }

  onAssetsUpdate() {
    // do nothing
  }

  onAssetChange() {
    // do nothing
  }

  onAssetAction() {
    this.selectedVehicle = this.asset;
    this.preSelectVehicle();
    this.showNewMessageForm = true;
  }

  onRouteAction() {
    // do nothing
  }

  onConfigurationLoad() {
    this.templates = this.configuration.otherSettings.messageTemplates;
  }

  private messageToActionMenuItem(message: MessageModel): ActionMenuItem {
    const actions: ActionMenuItemSubMenu[] = [];
    actions.push(new ActionMenuItemSubMenu('delete', 'Delete', () => this.deleteMessage(message)));
    return new ActionMenuItem(
      message.id,
      'message',
      message.subject,
      message.body,
      this.shortDateOrTimePipe.transform(new Date(message.createdAt)),
      `${this.seenMessagesCount(message)}/${message.messageDeliveries.length}`,
      null,
      () => false,
      null,
      null,
      () => {
        this.navigateToSelectedMessage(message);
      },
      null,
      null,
      actions
    );
  }

  private preSelectVehicle() {
    if (!!this.availableRecipients) {
      if (!!this.selectedVehicle) {
        const recipient = this.availableRecipients[0].recipients.find(recipient => recipient.id === this.selectedVehicle.id);
        if (!!recipient) {
          // remove all recipients
          this.formData.recipients = [];
          // add currently selected vehicle
          this.selected(recipient);
        }
      }
    }
  }

  onSendNewMessageClick() {
    this.showNewMessageForm = !this.showNewMessageForm;
    this.selectedVehicle = null;
    this.formData.recipients = [];
  }

  sendMessage() {
    this.isSending = true;
    this.messagesService
      .sendMessage(this.formData)
      .then(response => {
        this.messages.unshift(response.data);
        this.loadItems();

        this.toast.short('Message sent successfully.');
        this.isSending = false;
        this.showNewMessageForm = false;
        this.resetForm();
      })
      .catch((error: Error) => {
        console.error(error);
        this.toast.longer('Failed to send a message.');
        this.isSending = false;
      });
  }

  deleteMessage(message: MessageModel) {
    const dialogRef = this.dialog.open(ConfirmDeleteMessageDialogComponent, {
      data: { id: message.id, name: message.subject },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.messagesService
          .deleteMessage(message.id)
          .then(() => {
            const messageIndex = this.messages.findIndex(item => item.id === message.id);
            if (messageIndex > -1) {
              this.messages.splice(messageIndex, 1);
              this.loadItems();
            }
            this.openedMessage = null;
          })
          .catch(error => {
            console.error(error);
          });
      }
    });
  }

  remove(recipient: string): void {
    const index = this.formData.recipients.indexOf(recipient);

    if (index >= 0) {
      this.formData.recipients.splice(index, 1);
    }
  }

  selected(recipient: MessageRecipientModel): void {
    this.formData.recipients.push(recipient);
    if (!!this.recipientInput) {
      this.recipientInput.nativeElement.value = '';
    }
    this.recipientsForm.setValue(null);
  }

  getIconName(type: string): string {
    const mapping = {
      vehicle_group: 'groups',
      vehicle: 'directions_car',
      driver: 'person',
    };

    return mapping[type] ? mapping[type] : 'groups';
  }

  loadRecipients(): void {
    this.messagesService.getRecipients().then(response => {
      if (response.data) {
        this.availableRecipients = this.prepareRecipientsForDialog(response.data);
        if (!this.recipientsInitialized) {
          // preselect only on component initialization
          this.preSelectVehicle();
          this.recipientsInitialized = true;
        }
        this.recipientsForm.updateValueAndValidity({ onlySelf: false, emitEvent: true });
      }
    });
  }

  getRecipientsPlaceholder() {
    return this.isRecipientPresent() ? 'Search for active recipients' : 'No active recipients found';
  }

  isRecipientPresent(): boolean {
    if (!this.availableRecipients) {
      return false;
    }
    return Boolean(this.availableRecipients[0].recipients.length);
  }

  private _filterGroup(value: string): MessageRecipient[] {
    if (value) {
      return this.availableRecipients
        .map(group => ({ type: group.type, recipients: subFilter(group.recipients, value) }))
        .filter(group => group.recipients.length > 0);
    }

    return this.availableRecipients;
  }

  private prepareRecipientsForDialog(recipients: MessageRecipientCollectionModel): MessageRecipient[] {
    const mappedRecipients = [];

    mappedRecipients.push({
      type: 'Vehicles',
      recipients: recipients.vehicles,
    });

    mappedRecipients.push({
      type: 'Vehicle Groups',
      recipients: recipients.vehicleGroups,
    });

    if (recipients.vehicles.length) {
      mappedRecipients.push({
        type: 'System',
        recipients: [
          {
            name: 'Everyone',
            type: 'everyone',
          },
        ],
      });
    }

    return mappedRecipients;
  }

  private resetForm() {
    this.formData = {
      subject: '',
      body: '',
      recipients: [],
    };
  }

  navigateToSelectedMessage(selectedMsg: MessageModel) {
    this.openedMessage = selectedMsg;
  }

  seenMessagesCount(message: MessageModel) {
    if (!message.messageDeliveries.length) {
      return 0;
    }

    return message.messageDeliveries.filter(delivery => delivery.seenAt !== null).length;
  }

  onMessageClosed() {
    this.openedMessage = null;
  }

  onMessageDeleted(message: MessageModel) {
    this.deleteMessage(message);
  }

  onDateFilterChanged(dateFilter: DateFilter) {
    this.dateFilter = dateFilter;
    this.loadMessages();
  }

  onDriverFilterChanged(driverFilter: MultiSelectFilter<number>) {
    this.driverFilter = driverFilter;
    this.loadMessages();
  }

  onAuthorFilterChanged(authorFilter: MultiSelectFilter<string>) {
    this.authorFilter = authorFilter;
    this.loadMessages();
  }

  private loadMessages() {
    if (!!this.dateFilter && this.driverFilter && this.authorFilter) {
      this.messagesService
        .getMessages(
          !!this.dateFilter.from ? this.dateFilter.from : null,
          !!this.dateFilter.to ? this.dateFilter.to : null,
          this.driverFilter,
          this.authorFilter
        )
        .then(response => {
          this.messages = response.data;
          this.loadItems();
        });
    }
  }

  private loadItems() {
    this.items = this.messages.map(message => this.messageToActionMenuItem(message));
  }

  manageTemplates() {
    const dialogRef = this.dialog.open(ManageTemplatesComponent, {
      width: '800px',
      maxWidth: '800px',
      data: this.templates,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.configurationService.updateMessageTemplates(result)
          .then(() => {
            this.toast.short('Message templates saved.');
            this.templates = result;
          })
          .catch(error => {
            this.toast.long('Message templates NOT saved! Something went wrong.');
          });
      }
    });
  }

  copyTemplateToMessage(template: MessageTemplate) {
    this.formData.subject = template.title;
    this.formData.body = template.text;
  }
}
